import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { HiDeviceProvider } from 'src/context/HiDeviceContext';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: (props) => (props.isFold ? (props.showMenus ? 300 : 100) : 256)
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

function DashboardLayout({ children }) {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isSidePanelFold, setSidePanelFold] = useState(!!localStorage.getItem("fold"));
  const [showDrawerMenu, setShowDrawerMenu] = useState({ show: false, items: [] });
  const classes = useStyles({ isFold: isSidePanelFold, showMenus: showDrawerMenu.show });

  const fold = (v) => {
    if (v)
      localStorage.setItem("fold", "1");
    else
      localStorage.removeItem("fold");
    setSidePanelFold(v);
  };

  return (
    <div className={classes.root}>
      <HiDeviceProvider>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        isFold={isSidePanelFold}
        onFold={() => fold(true)}
        onUnfold={() => fold(false)}
        showDrawerMenu={showDrawerMenu}
        setShowDrawerMenu={setShowDrawerMenu}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            {children}
          </div>
        </div>
      </div>
      </HiDeviceProvider>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
